import { useState } from "react";
import { useForm } from "react-hook-form";
import { Form, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { Api } from "./api/Api";
import { LoginReq } from "./api/Application";
import { Input } from "./components/Input";
import { Button } from "./components/Button";
import { authAtom } from "./Atoms";
import { CenteredPage } from "./components/CenteredPage";
import { FaUser } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";

export function LoginPage() {
    const nav = useNavigate();
    const [user, setUser] = useAtom( authAtom );
    const [loginError, setLoginError] = useState<string>();
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm<LoginReq>( {
        defaultValues: { emailAddress: "", password: "" },
        shouldUnregister: false
    } );

    const onSubmit = async ( data: LoginReq ) => {
        const result = await Api.login( data );
        if ( result.isOk ) {
            setUser( {
                isAuthenticated: true,
                employee: result.value.employee,
                token: result.value.token,
            } );
            nav( "/detect/4" );
        } else {
            setLoginError( "Invalid username or password" );
        }
    };

    return <CenteredPage sm="10" md="8" lg="6" xl="4" style={{ maxWidth: "33em" }}>
        <Card className="w-100 shadow">
            <Card.Header className="h5 fw-bold">
                Login
            </Card.Header>
            <Card.Body className="p-4">
                <Form onSubmit={handleSubmit( onSubmit )}>
                    {loginError && <div className="alert alert-danger py-2">{loginError}</div>}
                    <Input
                        type="email"
                        icon={<FaUser className="fs-5 text-primary" />}
                        label="Email Address"
                        placeholder="Enter your email"
                        error={errors.emailAddress}
                        {...register( 'emailAddress', {
                            required: 'Email is required',
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: 'Invalid email address'
                            }
                        } )}
                    />

                    <Input
                        type="password"
                        icon={<RiLockPasswordFill className="fs-5 text-primary" />}
                        label="Password"
                        placeholder="Enter your password"
                        error={errors.password}
                        {...register( 'password', {
                            required: 'Password is required'
                        } )}
                    />
                    <div>
                        &nbsp;
                        {/* <Link to="/forgot">Forgot Password</Link> */}
                    </div>
                    <div className="d-flex gap-2">
                        <Button variant="secondary" className="w-100" onClick={() => nav( "/forgot" )}>
                            Forgot Password
                        </Button>
                        <Button className="w-100" type="submit">
                            Log In
                        </Button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    </CenteredPage>;
}